<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/league")
          i.fa.fa-trophy
          span.ml-1 {{ $tc("ui.leagues", 1) }}
      b-breadcrumb-item
        router-link(to="/league/purgeleague")
          i.fa.fa-trash
          span.ml-1 {{ $t("ui.purge_league") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.league_id") }}
                    DebounceInput(required type="text" v-model="purgeLeagueSearch" :placeholder="$t('message.search_by_league_name')")
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getPurgeLeagueList(true)"
                    variant="success"
                    size="sm"
                    ).mr-2
        div.card-body
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th(width=100)
                        span {{ $t('ui.id') }}
                      th(width=80)
                        span {{ $tc('ui.sports', 1) }}
                      th
                        span {{ $t("ui.name") }}
                      th(width=200)
                        span {{ $t("ui.parent_league") }}
                      th(width=100)
                        span {{ $t("ui.sbo") }}
                      th(width=100)
                        span {{ $t("ui.ibc") }}
                      th(width=100)
                        span {{ $t("ui.prefer") }}
                      th(width=60)
                        span {{ $t("ui.linked") }}
                      th(width=40).text-center
                        span(:title="$t('ui.mark_fetch')") {{ $t("ui.short.mark_fetch") }}
                      th.text-center(width=80)
                        span {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="purgeLeagueList.length == 0")
                      td(colspan="10").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in purgeLeagueList")
                      td
                        span {{ item.league_id }}
                      td
                        span {{ item.sport_type }}
                      td
                        span(:title="item.league_name") {{ item.league_name }}
                      td
                        span(:title="item.parent_league") {{ item.parent_league }}
                      td
                        span {{ item.sbo_map }}
                      td
                        span {{ item.ibc_map }}
                      td
                        span {{ item.prefer_id }}
                      td
                        span {{ item.link_id }}
                      td.text-center
                        span
                          i(:class="{'fas fa-check text-info': item.mark_fetch, 'fas fa-times text-warning': !item.mark_fetch  }")
                      td.actions
                        span
                          a.fa.fa-trash.text-primary(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    purgeLeagueSearch: '',
    purgeLeagueList: [],
    purgeLeagueTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
  },
  mounted: function() {
  },
  methods: {
    getDate(dateTime) {
      let convertDateFormat = this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getPurgeLeagueList: function() {
      let url = config.getPurgeLeagueListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.purgeleague,
        league_id: this.purgeLeagueSearch.trim()
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.purgeLeagueList = response.data.tbl_purge_league_list;
                if (this.purgeLeagueList.length == 0)
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.thisLeagueNotExists"), "error");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onDelete(item) {
      this.purgeLeague(item);
    },
    purgeLeague: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.purge_league"),
          text: this.$t("message.purge_league_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPurgeLeague(item);
          }
        });
    },
    confirmPurgeLeague(item) {
      let url = config.purgeLeagueUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.purgeleague,
        league_id: item.league_id,
        sbo_id: item.sbo_map,
        ibc_id: item.ibc_map
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.purgeLeagueList = [];
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>